
























import Vue, { PropType } from 'vue';
import { orderBy } from 'lodash';
import Rating from '@/components/Rating.vue';
import ListItem from './ListItem.vue';

export interface IReview {
  reviewerName: string;
  rating: number;
  comments?: string;
  ts: number;
}

export default Vue.extend({
  props: {
    avgRating: {
      type: Number,
      default: 0,
    },
    reviews: {
      type: Array as PropType<IReview[]>,
      default: [],
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    canShowMore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sortedReviews(): IReview[] {
      return orderBy(this.reviews, 'ts', 'desc');
    },
  },
  methods: {
    showMore(): void {
      this.$emit('show-more');
    },
  },
  components: {
    Rating,
    ListItem,
  },
});
